import { useContext, useEffect, useState } from "react";

import useAxios from "@hooks/use-axios";
import { UserContext } from "@context/user";
import { CURRENCY } from "@src/utility/constants/panel/common";
const usePublisherOverview = (publisherId) => {
    const { axiosInstance, loading } = useAxios({ base: "affiliate", initialLoader: true });
    const { publishers } = useContext(UserContext);
    const currency = CURRENCY;
    const [publisherStats, setPublisherStats] = useState({});
    const [brands, setBrands] = useState([]);
    const [paymentHistory, setPaymentHistory] = useState([]);
    const fetchSummary = async () => {
            const res = await axiosInstance.get(`v1/accounts/${publisherId}/dashboard/summary`);
            const result = res.data || res;
            const data = result.data || result;
            const brandEntries = data.earnings_by_brand || [];

            setPublisherStats((prev) => ({
                ...prev,
                next_expected_payout: data.stats?.next_expected_payout || 0,
                last_payment        : data.last_payment || null
            }));

            setBrands(brandEntries.map((entry) => ({
                id              : entry.account_id,
                name            : entry.account_name,
                platform        : entry.platform_name,
                kyc_status      : entry.kyc_status,
                payout_status   : entry.payout_stage,
                earnings_pending: entry.amount
            })));

    };

    const fetchKycStatus = async () => {
        try {
            const res = await axiosInstance.get(`v1/accounts/${publisherId}/kyc/details`);
            const result = res.data || res;
            const data = result.data || result;

            setPublisherStats((prev) => ({ ...prev, kyc_status: data.kyc_status || "not_started" }));
        } catch {
            setPublisherStats((prev) => ({ ...prev, kyc_status: "not_started" }));
        }
    };

    const fetchPaymentHistory = async () => {
        try {
            const res = await axiosInstance.get(`v1/accounts/${publisherId}/dashboard/payment-history`, { params: { page: 1, limit: 10 } });
            const result = res.data || res;
            const items = result.items || result.data || result.results || [];

            setPaymentHistory(items.map((entry, index) => ({
                id             : `${entry.period}-${index}`,
                period         : entry.period,
                brand_name     : entry.brand,
                amount         : entry.amount,
                status         : entry.status,
                confirmation_id: entry.confirmation_id
            })));
        } catch {
            setPaymentHistory([]);
        }
    };

    useEffect(() => {
        if (!publisherId) return;
        fetchSummary();
        fetchPaymentHistory();
        fetchKycStatus();
    }, [publisherId]); // eslint-disable-line react-hooks/exhaustive-deps

    const activePublisher = publishers.find((publisher) => publisher.id === publisherId);
    const publisher = { id: publisherId, name: activePublisher?.name, ...publisherStats };
    return { loading, currency, publisher, brands, paymentHistory };
};

export default usePublisherOverview;
